import { z } from "zod";

// ---------------------------------------------------------------------------
// Activity ("Data": last login, usage time)
//
// One doc per signed-in member, written by the webapp's heartbeat. Stored at:
//   Businesses/{businessId}/activity/{uid}
// ---------------------------------------------------------------------------

export interface ActivityRecord {
  uid: string;
  lastLoginAt: string | null;
  lastSeenAt: string | null;
  /** Minutes of use per day, YYYY-MM-DD -> minutes; pruned to ~30 days. */
  minutesByDay: Record<string, number>;
  updatedAt: string | null;
}

/** What the Data page lists per member. */
export interface ActivitySummary {
  uid: string;
  lastLoginAt: string | null;
  lastSeenAt: string | null;
  minutesLast7d: number;
}

export const HeartbeatInput = z.object({
  businessId: z.string().min(1),
  /** Minutes since the previous heartbeat, capped. */
  minutes: z.number().int().min(0).max(15),
  isLogin: z.boolean().optional(),
});
export type HeartbeatInput = z.infer<typeof HeartbeatInput>;

export const ListActivityInput = z.object({
  businessId: z.string().min(1),
});
export type ListActivityInput = z.infer<typeof ListActivityInput>;
